import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-salesmanagerorders-main",
    templateUrl: "./salesmanagerorders.main.component.html",
    standalone: false
})
export class SalesManagerOrdersMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
